import { Reducer } from 'redux';
import { reducer as simpleFormReducer, INITIAL_SIMPLEFORM_STATE } from 'app/infrastructure/simple-form/reducers';
import { MyCaseDraftsState, CaseDraftsTableState, CaseDraftRow } from './types-store';
import { STATE } from 'app/constants';
import { ACTION } from './action-types';

const INITIAL_CASE_DRAFTS_TABLE_STATE: CaseDraftsTableState = { rows: [], fetching: false, deleting: false };

const INITIAL_MY_CASE_DRAFTS_STATE: MyCaseDraftsState = {
  texts: {},
  validation: {},
  caseDraftsTable: INITIAL_CASE_DRAFTS_TABLE_STATE,
  ...INITIAL_SIMPLEFORM_STATE
} as any;

const filterDeletedDraft = (state: CaseDraftsTableState, draftId: number): CaseDraftRow[] =>
  state.rows.filter(r => r.draftId !== draftId);

type CaseDraftsHandler = (state: CaseDraftsTableState, action: any) => CaseDraftsTableState;

const CASE_DRAFTS_TABLE_HANDLERS: Record<string, CaseDraftsHandler> = {
  [ACTION.REQUEST_LOAD_DRAFTS]: () => ({ rows: [], fetching: true, deleting: false }),
  [ACTION.RECEIVE_LOAD_DRAFTS]: (_s, a) => ({ rows: a.rows, fetching: false, deleting: false }),
  [ACTION.FAIL_LOAD_DRAFTS]: () => ({ rows: [], fetching: false, deleting: false }),
  [ACTION.REQUEST_DELETE_DRAFT]: (s) => ({ ...s, deleting: true }),
  [ACTION.RECEIVE_DELETE_DRAFT]: (s, a) => ({ ...s, deleting: false, rows: filterDeletedDraft(s, a.draftId) }),
  [ACTION.FAIL_DELETE_DRAFT]: (s) => ({ ...s, deleting: false })
};

const caseDraftsTableReducer = (state: CaseDraftsTableState = INITIAL_CASE_DRAFTS_TABLE_STATE, action: any): CaseDraftsTableState => {
  const handler = CASE_DRAFTS_TABLE_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};

export const reducer: Reducer<MyCaseDraftsState> = (state: MyCaseDraftsState = INITIAL_MY_CASE_DRAFTS_STATE, action: any) => {
  const baseState = simpleFormReducer(STATE.myCaseDrafts)(state, action);
  return {
    ...baseState,
    caseDraftsTable: caseDraftsTableReducer(baseState.caseDraftsTable, action)
  };
};
